import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import { AddPaymentMethodButton } from '@/features/subscription/add-payment-method';
import type { PaywallState } from '../model/PaywallContext';

interface Props {
  open: boolean;
  paywallState: PaywallState | null;
  onClose: () => void;
}

export const PaywallModal = ({ open, paywallState, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth aria-labelledby="paywall-modal-title">
      <DialogTitle id="paywall-modal-title">{t('subscription.paywall.headline')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <DialogContentText>{t('subscription.paywall.body', { used: paywallState?.used ?? 0 })}</DialogContentText>
          <Link component={RouterLink} to="/settings/subscription" variant="body2" onClick={onClose}>
            {t('subscription.paywall.footerLink')}
          </Link>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {t('subscription.paywall.secondaryCta')}
        </Button>
        <AddPaymentMethodButton variant="contained" color="primary">
          {t('subscription.paywall.primaryCta')}
        </AddPaymentMethodButton>
      </DialogActions>
    </Dialog>
  );
};
